import type {
  GetDocumentsExternalFilesRequestType,
  GetDocumentsExternalFilesResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const getDocumentsExternalFiles = async (
  documentId: GetDocumentsExternalFilesRequestType['documentId'],
) => {
  const url = `/api/v2/documents/${documentId}/external-files`;
  const response =
    await apiAuthClient.get<GetDocumentsExternalFilesResponseType>(url);

  return response.data.data;
};
